<template>
	<div class="_create-boarding _modal bg-white">
		<div
			class="_modal__content px-12 py-6 flex flex-col items-center justify-center"
		>
			<div>
				<img
					alt="Luca Education"
					height="60"
					src="@/assets/images/illustrations/success.png"
					title="Luca Education"
					width="60"
				/>
			</div>
			<div
				class="_modal__content__title text-neutral-700 font-semibold text-2xl mt-5 text-center"
			>
				Cập nhật thông tin thành công
			</div>
			<div class="text-center text-neutral-500 mt-2">
				Hồ sơ đang được Luca Hub xem xét và phê duyệt. Bạn sẽ nhận được
				email thông báo khi hoàn tất.
			</div>
		</div>
		<div
			class="_modal__footer px-12 py-6 bg-neutral-50 flex flex-nowrap items-center"
		>
			<button
				class="button-p text-center mr-3 bg-none shadow-none text-neutral-500 hover:text-neutral-700"
				type="button"
				@click="$emit('close')"
			>
				Huỷ
			</button>
			<button
				class="button-p text-center whitespace-nowrap"
				type="button"
				@click="$emit('submit')"
			>
				Xác nhận
			</button>
		</div>
	</div>
</template>


